import { useState } from 'react'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import useLinkDetailsController from './useLinkDetailsController'
import { LinkChart } from './components/LinkChart'
import { TransactionsList } from './components/TransactionsList'
import QRCodeModal from '../components/QRCodeModal'
import { ArrowRight } from 'lucide-react'

const LinkDetails = () => {
  const [isQRCodeModalOpen, setIsQRCodeModalOpen] = useState(false)

  const {
    linkData,
    simulations,
    chartData,
    totalAccesses,
    allTransactions,
    contracts,
    totalValue,
    isLoading,
    isLoadingTransactions,
    getPageIndex,
    getPageCount,
    handleNextPage,
    handlePreviousPage,
  } = useLinkDetailsController()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-lg">Carregando...</div>
      </div>
    )
  }

  return (
    <div className="min-h-screen p-4">
      <div className="mb-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="rounded-lg bg-white02 p-6">
          <div className="mb-4 flex items-center justify-between">
            <h3 className="flex items-end gap-2 text-lg font-semibold text-gray-800">
              <i className="fa-solid fa-chart-simple text-2xl text-primary"></i>{' '}
              Acessos
            </h3>
            <div className="flex items-center gap-2 text-right">
              <p className="text-sm text-black01">Total:</p>
              <p className="text-xl font-bold text-primary">{totalAccesses}</p>
            </div>
          </div>

          <LinkChart data={chartData} isLoading={false} />
        </div>

        <div>
          <button
            onClick={() => setIsQRCodeModalOpen(true)}
            className="mb-6 flex h-12 w-full items-center justify-between gap-2 rounded-lg border border-primary bg-white02 px-4 py-2 font-medium text-primary hover:bg-white02"
          >
            <div className="flex items-center gap-2">
              <i className="fa-solid fa-qrcode text-2xl text-primary"></i>
              Compartilhar link
            </div>
            <ArrowRight className="text-primary" />
          </button>

          <div className="space-y-4">
            <div className="rounded-lg bg-white02 p-4">
              <p className="mb-1 text-sm text-black01">Simulações</p>
              <p className="text-2xl font-semibold text-gray-900">
                {simulations}
              </p>
            </div>
            <div className="rounded-lg bg-white02 p-4">
              <p className="mb-1 text-sm text-black01">Contratações</p>
              <p className="text-2xl font-semibold text-gray-900">
                {contracts}
              </p>
            </div>
            <div className="rounded-lg bg-white02 p-4">
              <p className="mb-1 text-sm text-black01">Valor total</p>
              <p className="text-2xl font-semibold text-black01">
                {formatMoneyValue(totalValue)}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <TransactionsList
          transactions={allTransactions}
          isLoading={isLoadingTransactions}
          getPageCount={getPageCount}
          getPageIndex={getPageIndex}
          handleNextPage={handleNextPage}
          handlePreviousPage={handlePreviousPage}
        />
      </div>

      <QRCodeModal
        isOpen={isQRCodeModalOpen}
        onClose={() => setIsQRCodeModalOpen(false)}
        linkName={linkData?.name || ''}
      />
    </div>
  )
}

export default LinkDetails
